import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-filmic-file',
  templateUrl: './filmic-file.component.html',
  styleUrls: ['./filmic-file.component.scss'],
})
export class FilmicFileComponent implements OnInit, OnChanges {
  @Input() filmicFile: MovieModel;


  fotoPrincipal = '';

  constructor(public san: DomSanitizer) { }

  ngOnInit(): void { }

  ngOnChanges(changes): void {
    if (changes['filmicFile']) {
      if (this.filmicFile) {
        // console.log(this.filmicFile)
        let fotoP = this.filmicFile.pictures.find((picture) => picture.isDefault == true);

        this.fotoPrincipal = environment.apiEndpoint + fotoP.pictureLink;
      }
    }
  }
}
